<template>
	<div>
		<video class="bg-video" src="/footage/metin.mp4" autoplay muted loop></video>
		<!--		<CircleLink v-for="pageLink in pageLinks" :link="pageLink"></CircleLink>-->
		<router-link :to="{name:'agac'}" class="page-nav-link" id="link-right"><img class="link-image" src="images/arrow-right-white-03.png " alt="" style="max-height: 55px;"></router-link>
		<CircleLink :link-route-name="'kazima'" :link-pos="[385,180]"></CircleLink>
		<CircleLink :link-route-name="'madalyon'" :link-pos="[993,249]"></CircleLink>


	</div>
</template>
<script>
	import CircleLink from "../components/CircleLink"
	import _ from 'lodash'

	export default {
		name: "MetinPage",
		components: {CircleLink},
		computed: {
			pageLinks: function () {
				var thisPagesLinks = _.find(this.$store.state.linksCollection, {'pageName': 'metin'})
				return thisPagesLinks.pageLinks
			}
		}
	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}

	.page-nav-link {
		position: absolute;
		top: 50%;
	}

	#link-right {
		right: 20px;
	}
</style>